module.exports = __webpack_public_path__ + "img/bg-visi.5f5d85c1.svg";